<template>
	<div class="right-box">
		<div v-if="itemData.createTime">
			<section class="sms-info">
				<div class="header">
					<span class="title" v-if="listQuery.type == 'single'">{{itemData.customerName || (isShowPhone ? itemData.mobileNum : hiddenPhone(itemData.mobileNum))}}</span>
					<span class="title" v-else>{{itemData.remark || (`群发：共${itemData.sendCount}人`)}}</span>
					<el-tag v-if="!itemData.scheduleTime && itemData.sendStatus == 'ready'" :type="$$(sendStatusObj[itemData.sendStatus], '1')" size="mini">待发送</el-tag>
					<el-tag v-else :type="$$(sendStatusObj[itemData.sendStatus], '1')" size="mini">{{$$(sendStatusObj[itemData.sendStatus], '0')}}</el-tag>
					
					<el-button @click.stop="handleSend" type="text" v-if="itemData.sendStatus == 'ready' && itemData.scheduleTime">修改</el-button>
					<span class="text">创建时间：{{itemData.createTime | formatDate}}</span>
					<span class="text">创建人：{{itemData.accountName}}</span>
				</div>
				<div class="content">
					<span v-if="itemData.sendStatus === 'ready' && itemData.scheduleTime" class="time" :class="itemData.sendStatus">预约时间：{{itemData.scheduleTime | formatDate}}2</span>
					<span v-if="itemData.sendStatus === 'sent'" class="time">发送时间：{{itemData.sendTime | formatDate}}</span>
					<span class="text">{{itemData.smsBody}}</span>
				</div>
			</section>

			<el-divider v-if="listQuery.type == 'group'"></el-divider>
			<section class="batch-info" v-if="listQuery.type == 'group'">
				<BatchInfo :itemData="itemData" />
			</section>
		</div>
		<el-empty v-else description="暂无数据"></el-empty>
		<el-drawer 
			title="短信单发"
            :visible.sync="dialogFormVisible"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="800px"
            direction="rtl">
			<TouchIn v-if="dialogFormVisible" type="edit" :itemData="itemData" @closeDialogFormVisible="handleCloseDialogFormVisible" />
        </el-drawer>

		<el-drawer 
			title="短信群发"
            :visible.sync="dialogFormVisibleGroup"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="800px"
            direction="rtl">
			<TouchInGroup v-if="dialogFormVisibleGroup" type="edit" :itemData="itemData" @closeDialogFormVisible="handleCloseDialogFormVisible" />
        </el-drawer>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import TouchIn from './TouchIn';
import { tableMixin } from "utils/mixins";
import BatchInfo from './BatchInfo';
import TouchInGroup from './TouchInGroup';
export default {
	props: ['listQuery', 'itemData'],
	mixins: [tableMixin],
	components: {BatchInfo, TouchIn, TouchInGroup},
	computed: {
        ...mapGetters([
			'isShowPhone'
        ])
    },
	data() {
		return {
			dialogFormVisible: false,
			dialogFormVisibleGroup: false,
			sendStatusObj: {
				'ready': ['预约中', 'warning'],
				'sent': ['已发送', 'success'],
				'failed': ['已失败', 'danger'],
				'cancel': ['已取消', 'info'],
				'': ['---', 'info']
			}
		}
	},
	created() {
		console.log(this.itemData)
	},
	methods: {
		handleSend() {
			if(this.listQuery.type == 'group') {
				this.dialogFormVisibleGroup = true;
			} else {
				this.dialogFormVisible = true;
			}
		},
		handleCloseDialogFormVisible() {
			this.dialogFormVisible = false;
			this.dialogFormVisibleGroup = false;
			this.$emit('onEmitList')
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
	}
}
</script>

<style lang="scss" scoped>
.right-box {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;

	& .sms-info {
		width: 100%;

		& > .header {
			width: 100%;
			height: 40px;
			padding: 0 12px;
			box-sizing: border-box;
			line-height: 40px;
			border-bottom: solid 1px #e1e1e1;

			& > .title {
				font-size: 14px;
				color: #333;
				font-weight: bold;
				margin-right: 12px;
			}

			& > .text {
				float: right;
				font-size: 12px;
				color: #666;
				margin-left: 12px;
			}

			& .el-button {
				// float: right;
				margin-left: 24px;
				margin-top: 2px;
			}
		}

		& > .content {
			width: 100%;
			padding: 12px;
			box-sizing: border-box;
			font-size: 15px;
			color: #333;
			line-height: 30px;
			letter-spacing: .5px;

			& > .time {
				display: block;
				line-height: 40px;
				text-align: center;
				font-size: 12px;

				&.ready {
					color: #e6a23c;
				}
			}

			& > .text {
				text-indent: 2em;
			}
		}
	}

	& > .batch-info {
		width: 100%;
		height: 800px;
		background: darkcyan;
	}
}
</style>